export const Mutation = {
  loading: "setLoading",
  notify: "notify",
  notifyApiError: "notifyApiError",
  entity: "entity",
  auth: {
    delete: 'authDelete',
    set: 'authSet',
    error: 'authError',
    setAccount: 'setAccount'
  },
  inventory: {
    setDevices: 'inventory/SET_DEVICES',
    setCompanies: 'inventory/SET_COMPANIES',
    setBatches: 'inventory/SET_BATCHES',
    addDevice: 'inventory/ADD_DEVICE',
    updateDevice: 'inventory/UPDATE_DEVICE',
    removeDevice: 'inventory/REMOVE_DEVICE'
  }
}